var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHelpCenter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#595959",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M426.5 218c-6.345 0-11.5 5.155-11.5 11.5s5.155 11.5 11.5 11.5 11.5-5.155 11.5-11.5-5.155-11.5-11.5-11.5zm0 1.045c5.78 0 10.455 4.675 10.455 10.455s-4.675 10.455-10.455 10.455-10.455-4.675-10.455-10.455 4.675-10.455 10.455-10.455zm0 4.182c-2.015 0-3.66 1.645-3.66 3.66-.002.188.097.363.26.458.163.095.364.095.527 0 .163-.095.262-.27.26-.459 0-1.45 1.163-2.613 2.613-2.613s2.614 1.164 2.614 2.613c.01 1.174-.62 1.806-1.397 2.54-.388.368-.803.742-1.143 1.21-.34.467-.597 1.05-.597 1.739v.261c-.002.189.097.364.26.46.162.094.364.094.527 0 .162-.096.261-.271.259-.46v-.261c0-.448.14-.781.392-1.127.251-.346.622-.685 1.02-1.062.797-.753 1.734-1.73 1.724-3.3v-.008c-.004-2.01-1.647-3.65-3.659-3.65zm0 10.978c-.433 0-.784.35-.784.784 0 .433.351.784.784.784.433 0 .784-.351.784-.784 0-.433-.351-.784-.784-.784z",
  transform: "translate(-415 -218)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHelpCenter);
export default ForwardRef;